const foodindicator = {
  getlist: 'foodindicator/getlist',
  add: 'foodindicator/add',
  update: 'foodindicator/update',
  remove: 'foodindicator/remove',
  get: 'foodindicator/get',
  getall: 'foodindicator/getall',
}
export default foodindicator
